export default __webpack_public_path__ + "02b9dd9642033122076f5f0ee74daf86.svg";